module.exports = __webpack_public_path__ + "static/img/logo.00d2e3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 24